// Mock data for Real Estate Developer Website

export const projects = [
  {
 id: 1,
    name: "SAI ADINATH MAJESTIC",
    location: "Beside MIT College, Beedbypass Road, Chh. Sambhajinagar",
    status: "Ready Possession",
    image: "https://i.postimg.cc/rsm63k5D/unnamed.jpg",
    gallery: [
      "https://i.postimg.cc/Prq6k3Ht/sai-adinath.jpg",
      "https://i.postimg.cc/rsm63k5D/unnamed.jpg",
      "https://i.postimg.cc/hPq3tTYS/01.jpg",
      "https://i.postimg.cc/jdQ3wCVZ/02.jpg",
      "https://i.postimg.cc/TYqNLh8t/03.jpg",
      "https://i.postimg.cc/FHrWjmNz/04.jpg",
      "https://i.postimg.cc/ncYSjM8y/05.jpg",
      "https://i.postimg.cc/jSM8c9SC/06.jpg",
      "https://i.postimg.cc/T3tk0S3D/07.jpg"
    ],
    brochureUrl: "https://drive.google.com/uc?export=download&id=1OuZzR0BRibONsMqvRRIuhgT7My0kzM11",
    price: "95 Lakhs",
    description: "Experience The Art Of Living.",
    bedrooms: "3BHK Spacious Apartments",
    area: "1,400 sq.ft Carpet Area ",
    amenities: ["Podium Garden", "Yoga Lawn"," Gazebo", "Pargola Sitting", "Leisure Walk", "Open Gym", "Clubhouse", "24/7 Security", "Smart Home", "Parking", ],
    timeline: "Completed",
    specifications: {
      floors: "10 Floors",
      units: "80 Flats And 13 Showrooms",
      parking: "Alloted Parking Spaces & Provisional Mechanised Parking "
    },
    virtualTour: "#",
    coordinates: { lat: 19.850483291974946, lng: 75.31742034303396 },
    mapLink: "https://maps.app.goo.gl/To13BpTBdrLL8RwM7"
  },   
  
  {
    id: 2,
    name: "MADHUBAN SQUARE",
    location: "Opp. New Hedgewar Hospital, Beedbypass Road, Gandheli, Chh. Sambhajinagar",
    status: "Ready To Build",
    image: "https://i.postimg.cc/DwxyXzL3/PRO-21-C1-copy-jpg.jpg",
    gallery: [
      "https://i.postimg.cc/43JYfLvZ/01.jpg",
      "https://i.postimg.cc/WpM61Kgt/02.jpg",
      "https://i.postimg.cc/k56W3hqH/03.jpg"
    ],
    price: " 25 Lakhs ",
    description: "Exclusive Gated Community With Independent Luxury Plots.",
    bedrooms: "Residential And Commercial Plots",
    area: "900 - 8,000 sq.ft",
    amenities: ["Garden", "Cement Road", "Indivisual Water Connection", "Smart Street Lamps", "Jogging Park","Underground Armoured Cable Elctricty Connection", "Kids Play Area", "Drainage Line", "Foothpath With Paver Blocks", "Two Side DP Road Approch" ],
    timeline: "Ready for Immediate Construction",
    specifications: {
      plotSize: "800 - 6,000 sq.ft",
      units: "143 Primium NA Plots",
      
    },
    brochureUrl: "https://drive.google.com/uc?export=download&id=1RGYtDNOtGY4rT10Foa80LqQ-44pzXwRp",
    virtualTour: "#",
    coordinates: { lat: 19.837971, lng: 75.389644 },
    mapLink: "https://www.google.com/maps?q=19.837971,75.389644"
  }, 
  {
    id: 3,
    name: "SHANTI NAGAR PHASE-Ⅱ",
    location: "Near Cricket Stadium, Golwadi, Paithan Road, Chh. Sambhajinagar",
    status: "Ready To Build",
    image: "https://i.postimg.cc/02Xqh6zQ/01.jpg",
    gallery: 
    [
      "https://i.postimg.cc/02Xqh6zQ/01.jpg",
      "https://i.postimg.cc/KYypWFDP/02.jpg",
      "https://i.postimg.cc/j29Z4rjd/03.jpg",
      "https://i.postimg.cc/dVG4rpcy/04.jpg",
      
    ],
    price: " 60 Lakhs ",
    description: "Transforming Land Into Lifestyles.",
    bedrooms: " Ultra Luxury And Exclusive Bunglow Plots",
    area: "1350 - 6000 sq.ft",
    amenities: ["Kids Play Area", "Open Gym", "Temple", "Gated Community", "Walking Plaza", "Water Supply Connection", "Street Lights", "Drainage Line","Open Space Plantation", "Two Side DP Road Approch", "Underground Armoured Cable Electricity Connection", "Foothpaths With Paver Blocks"],
    timeline: "Ready To Build",
    specifications: {
      floors: "Ground Floor",
      units: "44 Plots",
      parking: "individual Parking"
    },
    brochureUrl: "https://drive.google.com/file/d/1QJD3X6DEdo_VXq1q8_L8BqVS_N1wSiQZ/view?usp=sharing",
    virtualTour: "#",
    coordinates: { lat: 19.847664, lng: 75.280826 },
    mapLink: "https://www.google.com/maps?q=19.847664,75.280826"
  },
  {
    id: 4,
    name: "MADHUBAN HEIGHTS",
    location: "Mitra Nagar, Near Akashwani Chowk, Chh. Sambhajinagar",
    status: " Under Construction",
    image: "https://i.postimg.cc/wjNtZd3D/Madhuban-Height-Building.png",
    gallery: 
    [
      "https://i.postimg.cc/tCQq2nV4/01.jpg",
      "https://i.postimg.cc/JzTWVst4/02.jpg",
      "https://i.postimg.cc/5N3hLX5W/03.jpg",
      "https://i.postimg.cc/yxTbmGZV/04.jpg",
      "https://i.postimg.cc/pTbGgvQY/05.jpg",

    ],
    price: "1.91CR ",
    description: "Shaping The Skyline, Setting The Stage.",
    bedrooms: "4 BHKD",
    area: "1800 sq.ft",
    amenities: ["One Floor One Flat", "Gated Entry", "Fire Fighting Hydrant", "CCTV Security", "Powerbackups Of Lifts", "Seat Out & Gazebo at Terrace", "Ample Parking Space", "Solar", "Camera Door", "Waiting Area", "EV Charging Connection", "Wooden Flooring", "Fall Cealing", "Luxurios Entrance Lobby"],
    timeline: "Expected Completion: Q4 2026",
    specifications: {
      floors: "6 Floors",
      units: "6 Ultra Luxry Recidencial Flats",
      parking: "2 Covered Parking Spaces"
    },
    brochureUrl: "https://drive.google.com/uc?export=download&id=1WcBwqlZgFNJbmxNbB685nHp_znusi9BT",
    virtualTour: "#",
    coordinates: { lat: 19.87413, lng: 75.34405 },
    mapLink: "https://www.google.com/maps?q=19.87413,75.34405"
  },
  {
    id: 5,
    name: "Gut No 10/02 Shahajapur",
    location: "Behind Tanwani School, Shahajapur, Dhule Solapur Highway, Chh.Sambhajinagar ",
    status: "Launching Soon",
    image: "https://i.ibb.co/4nrhSFT5/coming-soon-3d-label-promotion-banner-png.png",
    price: "20 Lakhs",
    description: "Drafting Tomorrow’s Landmarks Today.",
    bedrooms: "Primium NA Plots",
    area: "800 - 1500 sq.ft",
    amenities: ["Water Line", "Drainage Line", "Garden", "Cement Roads", "Paver Blocks", "Street Lamps"],
    timeline: "Launching In Q2:2026",
    specifications: {
      floors: "Ground Floor",
      units: "*** Plots",
      parking: "Individual Parking"
    },
    virtualTour: "#",
    coordinates: { lat: 19.875404, lng: 75.238591 },
    mapLink: "https://www.google.com/maps?q=19.875404,75.238591"
  },
  {
    id: 6,
    name: "KRK GULMOHOR",
    location: "Gut No 103, Near Hindustan Awas, Patoda Road, Paithan Road, Chh. Sambhajinagar",
    status: "Ready To Build",
    image: "https://i.ibb.co/MydPnBJz/KRK-cover.png",
    price: "16.50 Lakhs",
    description: "Primium NA-44 Plots In Peacefull Environment.",
    bedrooms: "Pure Residencial Plots",
    area: "651 - 1060 sq.ft",
    amenities: ["Cement Roads", "Smart Streen Lights", "Corporation Water Supply", "Two Big Open Space", "Gated Community", "Garden"],
    timeline: "Complited",
    specifications: {
      floors: "-",
      units: "64 Plots",
      parking: "-"
    },
    virtualTour: "#",
    coordinates: { lat: 19.82121, lng: 75.279934 },
    mapLink: "https://www.google.com/maps?q=19.82121,75.279934"
  },
  
  {
    id: 7,
    name: "GUT NO.131, GANDHELI",
    location: " Beedbypass Road, Gandheli, Chh. Sambhajinagar",
    status: "Launching Soon",
    image: "https://i.ibb.co/4nrhSFT5/coming-soon-3d-label-promotion-banner-png.png",
    gallery: [
      "https://i.ibb.co/9HFpYm16/Madhuban-Square-Map.png",
      "https://i.ibb.co/wZ03sTyM/aqinnhd-1771311409-714181923-sm.jpg",
      "https://i.ibb.co/k2kcdxkM/v03hlmi-1771311410-714181925-opt-Orig.jpg"
    ],
    price: " 50 Lakhs ",
    description: "Exclusive Gated Community With Independent Luxury Plots.",
    bedrooms: "Residencial And Commercial Plots",
    area: "800-4000 sq.ft",
    amenities: ["Garden", "Cement Road", "Indivisual Water Connection", "Smart Street Lamps", "Jogging Park","Underground Armoured Cable Elctricty Connection", "Kids Play Area", "Drainage Line", "Foothpath With Paver Blocks", "Two Side DP Road Approch" ],
    timeline: "Laucnhing Soon",
    specifications: {
      plotSize: "800 - 4,000 sq.ft",
      units: "100 Primium NA Plots",
      
    },
    brochureUrl: "",
    virtualTour: "#",
    coordinates: { lat: 19.841840796407965, lng: 75.40405581740978 },
    mapLink: "https://maps.app.goo.gl/w5vVEvJXrvSika4z5"
  },
  {
    id: 8,
    name: "ARAS VENTURES",
    location: "Sutgirni Chowk, Shivaji Nagar, Chh. Sambhajinagar",
    status: "Launching Soon",
    image: "https://i.postimg.cc/CxQnD7MS/aras-2.png",
    gallery: [
      "https://i.ibb.co/9HFpYm16/Madhuban-Square-Map.png",
      "https://i.ibb.co/wZ03sTyM/aqinnhd-1771311409-714181923-sm.jpg",
      "https://i.ibb.co/k2kcdxkM/v03hlmi-1771311410-714181925-opt-Orig.jpg"
    ],
    price: " 1.95 Cr ",
    description: "Exclusive Residence With Ultra Luxury Flats.",
    bedrooms: "Above 4BHK ",
    area: "1500 sq.ft Carpet Area",
    amenities: ["One Floor One Flat", "Gated Entry", "Fire Fighting Hydrant", "CCTV Security", "Powerbackups Of Lifts", "Seat Out & Gazebo at Terrace", "Ample Parking Space", "Solar", "Camera Door", "Waiting Area", "EV Charging Connection", "Wooden Flooring", "Fall Cealing", "Luxurios Entrance Lobby"],
    timeline: "Q4 2027",
    specifications: {
      plotSize: "1500 sq ft Carpet Area",
      units: "Residencial Flats And Showroom",
      
    },
    brochureUrl: "",
    virtualTour: "#",
    coordinates: { lat: 19.858383, lng: 75.349990 },
    mapLink: "https://www.google.com/maps?q=19.858383,75.349990"
  },
  {
    id: 9,
    name: "LABH URBAN MEADOWS",
    location: "Golwadi, Chh. Sambhajinagar",
    status: "Ready To Build",
    image: "https://i.postimg.cc/pTcwXNV7/med.png",
    gallery: [
      "https://i.postimg.cc/pTcwXNV7/med.png",
      "https://i.postimg.cc/XYwXZLCG/3.png",
      "https://i.postimg.cc/XqR7qBNc/4.png"
    ],
    price: " 55 Lakhs ",
    description: "Exclusive Gated Community With Independent Luxury Plots.",
    bedrooms: "Residential And Commercial Plots",
    area: "1200 - 6,000 sq.ft",
    amenities: ["Garden", "Cement Road", "individual Water Connection", "Smart Street Lamps", "Jogging Park","Underground Armoured Cable Elctricty Connection", "Kids Play Area", "Drainage Line", "Foothpath With Paver Blocks", "Two Side DP Road Approch" ],
    timeline: "Ready for Immediate Construction",
    specifications: {
      plotSize: "1200 - 4,000 sq.ft",
      units: "42 Primium NA Plots",
      
    },
    brochureUrl: "",
    virtualTour: "#",
    coordinates: { lat: 19.836614170111137, lng: 75.27897462849398 },
    mapLink: "https://maps.app.goo.gl/oVgX54mG8xYUpGDP8"
  },
    ];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Patil",
    role: "Homeowner, SAI ADINATH MAJESTIC",
    rating: 5,
    text: "The 3BHK apartment at SAI ADINATH MAJESTIC exceeded all our expectations. The podium garden and smart home features are fantastic. KIANA DEVELOPERS delivered on every promise!"
  },
  {
    id: 2,
    name: "Priya Deshmukh",
    role: "Investor, MADHUBAN SQUARE",
    rating: 5,
    text: "Purchased a plot at MADHUBAN SQUARE and the location is prime! Near Chate School and excellent connectivity. The NA plot approval process was smooth and transparent."
  },
  {
    id: 3,
    name: "Amit Joshi",
    role: "Resident, MADHUBAN HEIGHTS",
    rating: 5,
    text: "Living in MADHUBAN HEIGHTS has been a dream. One floor, one flat concept gives ultimate privacy. The 4BHKD is spacious and the Mitra Nagar location is perfect for our family."
  },
  {
    id: 4,
    name: "Sneha Kulkarni",
    role: "Homeowner, SAI ADINATH MAJESTIC",
    rating: 5,
    text: "The terrace garden and yoga lawn are my favorite amenities. Quality construction and timely possession made this the best investment decision!"
  },
  {
    id: 5,
    name: "Vijay Sonawane",
    role: "Investor, KRK GULMOHOR",
    rating: 4,
    text: "Great residential plot project in a peaceful environment. The cement roads and smart street lights add good value. Slightly delayed documentation but overall satisfied."
  },
  {
    id: 6,
    name: "AnjaliMore",
    role: "Homeowner, MADHUBAN HEIGHTS",
    rating: 5,
    text: "The fire fighting hydrant, CCTV security, and ample parking make me feel safe. KIANA DEVELOPERS truly thinks about every detail!"
  },
  {
    id: 7,
    name: "Sanjay Kale",
    role: "Investor, SHANIT NAGAR",
    rating: 5,
    text: "Booked a villa plot near Cricket Stadium on Paithan Road. The location appreciation potential is tremendous. Excellent connectivity to all major areas."
  },
  {
    id: 8,
    name: "Madhuri Bhosale",
    role: "Resident, SAI ADINATH MAJESTIC",
    rating: 5,
    text: "The 24/7 security and clubhouse amenities make life so convenient. My kids love the open gym and leisure walk area. Worth every rupee!"
  },
  {
    id: 9,
    name: "Rahul Jadhav",
    role: "Homeowner, MADHUBAN SQUARE",
    rating: 4,
    text: "Good residential and commercial plot options. The sports complex and jogging park are well-maintained. Would have liked better road access during monsoon."
  },
  {
    id: 10,
    name: "Kavita Pawar",
    role: "Investor, KRK GULMOHOR",
    rating: 5,
    text: "Premium NA plots with corporation water supply. The two big open spaces and garden are great additions. Excellent investment near Hindustan Awas!"
  },
  {
    id: 11,
    name: "Deepak Shinde",
    role: "Homeowner, MADHUBAN HEIGHTS",
    rating: 5,
    text: "The 2400 sq.ft carpet area is incredibly spacious. Power backup for lifts and seat out at terrace are thoughtful touches. Highly recommend!"
  },
  {
    id: 12,
    name: "Pooja Gaikwad",
    role: "Resident, SAI ADINATH MAJESTIC",
    rating: 5,
    text: "Location beside Kamalnayan Bajaj Hospital is perfect. The mechanised parking and 10-floor structure is impressive. Great community living!"
  },
  {
    id: 13,
    name: "Santosh Nikam",
    role: "Investor, SHANIT NAGAR",
    rating: 5,
    text: "46 luxury villa plots in gated community near Golwadi. The walking plaza and temple add cultural value. Smart investment choice!"
  },
  {
    id: 14,
    name: "Manisha Sawant",
    role: "Homeowner, MADHUBAN SQUARE",
    rating: 4,
    text: "144 premium NA plots with ready-to-build status. Kids play area is nice. Minor delay in plot handover but compensated well by the team."
  },
  {
    id: 15,
    name: "Anil Thorat",
    role: "Investor, KRK GULMOHOR",
    rating: 5,
    text: "64 plots in peaceful environment on Patoda Road. Gated community with excellent road infrastructure. KIANA quality is unmatched!"
  },
  {
    id: 16,
    name: "Rupali Chavan",
    role: "Resident, MADHUBAN HEIGHTS",
    rating: 5,
    text: "Behind Akashwani Chowk location is central yet peaceful. Ultra luxury finishes in every corner. The seat out and gazebo at terrace is stunning!"
  },
  {
    id: 17,
    name: "Prakash Ingle",
    role: "Homeowner, SAI ADINATH MAJESTIC",
    rating: 5,
    text: "1200 sq.ft carpet area with smart home technology. The podium garden and pargola sitting area are beautifully designed. Very happy with the purchase!"
  },
  {
    id: 18,
    name: "Swati Kamble",
    role: "Investor, MADHUBAN SQUARE",
    rating: 5,
    text: "Near New Hedgewar Hospital with commercial plot options. Great for business setup. The garden and sports complex add recreational value!"
  },
  {
    id: 19,
    name: "Ganesh Waghmare",
    role: "Homeowner, SHANIT NAGAR",
    rating: 4,
    text: "Luxury villa plot with good specifications. Open gym and kids play area are well-planned. Construction guidelines could be clearer."
  },
  {
    id: 20,
    name: "Archana Mahajan",
    role: "Resident, SAI ADINATH MAJESTIC",
    rating: 5,
    text: "The 80 apartments and 13 commercial shops create a vibrant community. Yoga lawn is my morning sanctuary. Excellent living experience!"
  },
  {
    id: 21,
    name: "Amol Sawant",
    role: "Investor, KRK GULMOHOR",
    rating: 5,
    text: "Good residential and commercial plot options"
  },
  
  ];

export const companyInfo = {
  name: "KIANA DEVELOPERS",
  tagline: "Building Dreams, Creating Landmarks",
  about: "With over 20+ years of excellence in real estate development, we have delivered more than 10 landmark projects across prime locations. Our commitment to quality, innovation, and customer satisfaction With PASSION, CREATION and PERFECTION has made us one of the most trusted names in luxury real estate.",
  experience: "20+ Years",
  projects: "10+ Completed",
  customers: "2,000+ Happy Families",
  awards: "5+ Industry Awards",
  contact: {
    phone: "+91 9561774777",
    whatsapp: "+91 9561774777",
    email: "admin@kianadevelopers.com",
    address: "Office No.101/102, Apna Bazar Complex, Sevenhills, Jalna Road, Chhatrapati Sambhajinagar.431001.",
    mapLink: "https://www.google.com/maps?q=19.875682,75.348924"
  },
  social: {
    facebook: "https://www.facebook.com/p/Kiana-Developers-61555850777164/",
    twitter: "#",
    instagram: "https://www.instagram.com/kianadevelopers?igsh=d3J1ZzRyNnhtbTF4",
    linkedin: "#"
  }
};
